export default {
  data() {
    return {
      breadcrumbImage: {
        switch: false,
        search: '',
        page: 1,
        loaded: false,
        errors: [],
      },
    }
  },
  computed: {
    breadcrumbImages: function () {
      return this.$store.getters['image/filteredBreadcrumbItems']({
        searchText: this.breadcrumbImage.search,
        page: this.breadcrumbImage.page,
      })
    },
    breadcrumbImageNextCount: function () {
      const imageCount = this.breadcrumbImages.count - this.breadcrumbImages.data.length
      return imageCount > 6 ? 6 : imageCount
    },
  },
  methods: {
    onNextBreadcrumbImagesClick() {
      this.breadcrumbImage.page += 1
    },
    onBreadcrumbImageSwitchChange(checked) {
      if (checked && !this.breadcrumbImage.loaded) {
        this.loading = true
        this.$store.dispatch('image/getOnlyBreadcrumbs')
          .catch(() => {})
          .finally(() => {
            this.loading = false
            this.breadcrumbImage.loaded = true
          })
      }
    },
  },
}
